import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-face-icon',
  templateUrl: './face-icon.component.html',
  styleUrls: ['./face-icon.component.scss'],
  preserveWhitespaces: false
})
export class FaceIconComponent implements OnInit {
  @Input('imageUrl') imageUrl: string;
  @Input('iconSize') iconSize: number;
  @Input('name') name: string;
  _iconPath: string;
  _defaultPath = '/assets/img/user.png';

  constructor() { }

  ngOnInit() {
  }

  @Input('imageUrl')
  set value(img: string) {
    this._update(img);
  }

  @Input('iconSize')
  set _iconSize(size: number) {
    this.iconSize = size;
  }

  @Input('name')
  set _name(value: string) {
    this.name = value;
  }

  private _update(img: string) {
    this._iconPath = '';
    this._iconPath = img ? (this._iconPath + img) : this._defaultPath;
  }

  setDefaultAvatar() {
    this._iconPath = this._defaultPath;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/face-icon/face-icon.component.ts